
        import * as module0 from './controllers/scroll_controller.js';import * as module1 from './controllers/video_controller.js'
        const modules = {
            "./controllers/scroll_controller.js": module0,
            "./controllers/video_controller.js": module1,
        };
        export default modules;
      